export default {
  'nav.brand': 'AllChinaBuy Spreadsheet',
  'nav.categories': 'Catégories',
  'nav.guides': 'Guides',
  'nav.faq': 'FAQ',
  'nav.explore': 'Explorer le Spreadsheet',
  'nav.home': 'Accueil',
  'nav.shoppingGuide': 'Guide d’achat',
  'nav.sheetCta': 'AllChinaBuy Sheet',

  'hero.badge': 'MIS À JOUR CHAQUE SEMAINE · ÉDITION 2026',
  'hero.title': 'Le répertoire AllChinaBuy Spreadsheet le plus complet',
  'hero.titlePre': 'Le plus complet',
  'hero.titleHighlight': 'AllChinaBuy Spreadsheet',
  'hero.titleSuffix': 'Répertoire',
  'hero.subtitle': 'Découvrez des milliers de trouvailles produits soigneusement sélectionnées : chaussures, vêtements, sacs, accessoires et plus encore. Mis à jour chaque semaine avec des annonces vérifiées et des catégories organisées pour les acheteurs avisés.',
  'hero.cta1': 'AllChinaBuy Sheet',
  'hero.cta2': 'Acheter maintenant',
  'hero.trust1': 'Mis à jour chaque semaine',
  'hero.trust2': 'Qualité vérifiée',
  'hero.trust3': 'Vérifié',

  'trust.independent': 'Ressource indépendante',
  'trust.research': 'Axé sur la recherche',
  'trust.updated': 'Mis à jour régulièrement',

  'selector.title': 'Parcourir par catégorie',
  'selector.placeholder': 'Choisir une catégorie…',
  'selector.all': 'Toutes les catégories',

  'categories.title': 'Catégories populaires',
  'categories.badge': 'CURATÉ',
  'categories.intro': 'Parcourez notre collection soigneusement organisée de spreadsheets AllChinaBuy. Chaque catégorie renvoie directement vers des annonces produits vérifiées sur notre boutique principale.',
  'categories.subtitle': 'Choisissez une catégorie pour explorer les produits correspondants sur le site principal.',
  'categories.browse': 'Parcourir cette catégorie',

  'features.title': 'Pourquoi utiliser un spreadsheet pour la recherche de produits ?',
  'feature1.title': 'Tout au même endroit',
  'feature1.desc': 'Parcourez chaussures, vêtements, sacs et plus depuis un hub organisé au lieu de chercher sur de nombreuses pages.',
  'feature2.title': 'Des catégories claires',
  'feature2.desc': 'Accédez directement à la catégorie qui vous intéresse grâce à un menu déroulant rapide ou des boutons en un clic.',
  'feature3.title': 'Indépendant et honnête',
  'feature3.desc': 'Une ressource indépendante axée sur la découverte, sans faux avis, prix ni coupons.',

  'guide.title': 'Qu’est-ce que le AllChinaBuy Spreadsheet ?',
  'guide.p1': 'Un spreadsheet AllChinaBuy est une façon organisée de parcourir les trouvailles produits. Il regroupe les articles populaires en catégories claires — chaussures, sweats, t-shirts, vestes, pantalons, accessoires et plus — pour vous aider à découvrir des produits rapidement et planifier des achats plus intelligents.',
  'guide.p2': 'Au lieu de chercher page par page, utilisez les catégories ci-dessus pour accéder directement à la section dont vous avez besoin. Chaque lien vous emmène vers la catégorie correspondante du site principal.',
  'guide.p3': 'Il s’agit d’une ressource indépendante axée sur la découverte de produits. Nous privilégions des conseils utiles et originaux — sans faux avis, prix ni coupons — pour que vous sachiez toujours ce que vous regardez.',
  'guide.readMore': 'Lire le guide complet',
  'guide.readMoreSub': 'Apprenez à utiliser le spreadsheet pour la recherche de produits, avec des conseils pratiques et une FAQ.',

  'companion.badge': 'À propos d’AllChinaBuy Sheet',
  'companion.title': 'Votre compagnon d’achat ultime',
  'companion.p1': 'Le <strong>AllChinaBuy spreadsheet</strong> est devenu un outil essentiel pour des milliers d’acheteurs avisés dans le monde. Que vous recherchiez les dernières sorties de sneakers, des pièces streetwear premium ou des pépites de luxe cachées, un <strong>répertoire de produits</strong> bien organisé peut vous faire gagner des heures de navigation et vous aider à découvrir des produits que vous n’auriez jamais trouvés seul.',
  'companion.p2': 'Notre répertoire <strong>AllChinaBuy spreadsheet 2026</strong> rassemble la collection la plus complète de trouvailles vérifiées — des sneakers Nike et Jordan aux hoodies Essentials, en passant par les accessoires Chrome Hearts et bien plus. Chaque spreadsheet est régulièrement mis à jour pour que vous ayez toujours accès aux sorties les plus fraîches et aux articles au meilleur rapport qualité-prix.',
  'companion.p3': 'Ce qui distingue notre répertoire, c’est le niveau de curation. Nous ne listons pas tous les spreadsheets que nous croisons. Chaque entrée de notre collection <strong>AllChinaBuy spreadsheet</strong> est examinée manuellement pour sa qualité, son exactitude et sa pertinence. Vous passez ainsi moins de temps à trier des liens morts et plus de temps à trouver exactement ce que vous voulez.',
  'companion.cta1': 'Visiter la boutique principale',
  'companion.cta2': 'Lire le guide complet',

  'why.badge': 'POURQUOI NOUS CHOISIR',
  'why.title': 'La confiance de milliers d’acheteurs',
  'why.subtitle': 'Notre répertoire AllChinaBuy spreadsheet repose sur la fiabilité, la fraîcheur et les retours réels des utilisateurs — voici ce qui en fait la ressource incontournable des acheteurs avisés en 2026.',
  'why.f1.title': 'Mis à jour chaque semaine',
  'why.f1.desc': 'Notre répertoire est actualisé chaque semaine avec les dernières trouvailles, pour ne jamais manquer une nouvelle sortie ou un article tendance.',
  'why.f2.title': 'Qualité vérifiée',
  'why.f2.desc': 'Chaque spreadsheet est examiné manuellement avant d’être listé. Nous vérifions les liens morts, les prix obsolètes et les descriptions inexactes.',
  'why.f3.title': 'Catégories organisées',
  'why.f3.desc': 'Parcourez 14 catégories soigneusement organisées — des sneakers et hoodies aux accessoires et parfums — pour trouver exactement ce qu’il vous faut en quelques secondes.',
  'why.f4.title': 'Navigation rapide',
  'why.f4.desc': 'Des liens directs vers des annonces vérifiées sur notre boutique principale éliminent les incertitudes et vous font passer de la navigation à l’achat plus vite que jamais.',
  'why.f5.title': 'Guides comparatifs',
  'why.f5.desc': 'Des comparaisons côte à côte vous aident à évaluer différentes options de spreadsheet, de tarifs et de recommandations d’agents avant de vous engager.',
  'why.f6.title': 'Dernières trouvailles',
  'why.f6.desc': 'Gardez une longueur d’avance grâce à un accès anticipé aux pépites récemment découvertes, aux sorties limitées et aux bonnes affaires discrètes dans toutes les catégories.',

  'faq.title': 'Questions fréquentes',
  'faq.subtitle': 'Tout ce que vous devez savoir sur les spreadsheets AllChinaBuy, leur fonctionnement et comment tirer le meilleur parti de notre répertoire.',
  'faq.q1': 'Est-ce un site officiel AllChinaBuy ?',
  'faq.a1': 'Non, il s’agit d’une ressource d’information indépendante, non exploitée par AllChinaBuy et sans affiliation.',
  'faq.q2': 'Où puis-je acheter les produits ?',
  'faq.a2': 'Tous les liens de catégories vous mènent au site principal, où vous pouvez parcourir les annonces complètes et effectuer vos achats.',
  'faq.q3': 'Le spreadsheet est-il gratuit ?',
  'faq.a3': 'Oui, parcourir les catégories et les guides ici est entièrement gratuit.',
  'faq.q4': 'Comment trouver un article précis ?',
  'faq.a4': 'Choisissez la catégorie la plus proche dans le menu ou les boutons, puis parcourez les annonces liées.',
  'faq.q5': 'À quelle fréquence les spreadsheets sont-ils mis à jour ?',
  'faq.a5': 'Nous visons à maintenir les catégories et les guides à jour. Revenez régulièrement pour les dernières trouvailles et conseils.',
  'faq.q6': 'Puis-je soumettre mon propre spreadsheet ?',
  'faq.a6': 'Actuellement, nous n\'acceptons pas les soumissions des utilisateurs. Toutes les listes sont curatées manuellement par notre équipe éditoriale.',

  'cta.title': 'Prêt à explorer le AllChinaBuy Spreadsheet ?',
  'cta.subtitle': 'Parcourez les catégories et les trouvailles, ou rendez-vous directement sur le site principal.',
  'cta.button1': 'AllChinaBuy Spreadsheet',
  'cta.button2': 'Acheter maintenant',

  'finalcta.title': 'Prêt à dénicher votre prochaine bonne affaire ?',
  'finalcta.subtitle': 'Rejoignez des milliers d’acheteurs avisés qui utilisent déjà notre répertoire AllChinaBuy spreadsheet. Mis à jour chaque semaine avec les dernières trouvailles vérifiées dans 14 catégories.',
  'finalcta.button1': 'Parcourir les spreadsheets',
  'finalcta.button2': 'Lire le guide',

  'guides.badge': 'Guides d’achat',
  'guides.title': 'Guides d’achat AllChinaBuy',
  'guides.subtitle': 'Des guides originaux et détaillés pour rechercher des produits, commander sereinement et expédier plus intelligemment.',

  'footer.description': 'Un hub de ressources indépendant pour les trouvailles, catégories et guides d’achat AllChinaBuy.',
  'footer.tagline': 'Ajoutez notre site à vos favoris et revenez chaque semaine pour les dernières mises à jour du AllChinaBuy spreadsheet, les nouvelles catégories et les trouvailles fraîches dans les 14 catégories.',
  'footer.readGuide': 'Lire le guide complet',
  'footer.popularCategories': 'Catégories populaires',
  'footer.quickLinks': 'Liens rapides',
  'footer.mainStore': 'Boutique principale — AllChinaBuy Sheet',
  'footer.buyNow': 'Acheter maintenant',
  'footer.completeGuide': 'Guide complet 2026',
  'footer.allCategories': 'Toutes les catégories',
  'footer.faq': 'FAQ',
  'footer.home': 'Accueil',
  'footer.mainStoreShort': 'Boutique principale',
  'footer.copyright': 'Tous droits réservés. Sans affiliation avec AllChinaBuy.',
  'footer.categoriesLink': 'Catégories',
  'footer.guideLink': 'Guide d’achat',
  'footer.faqLink': 'FAQ',
  'footer.disclaimer': 'Il s’agit d’une ressource d’information indépendante, non exploitée par AllChinaBuy et sans affiliation.',
  'footer.rights': 'Tous droits réservés.',
  'footer.externalNote': 'Les liens vers le site principal s’ouvrent dans un nouvel onglet.',

  'categories.shoes': 'Chaussures',
  'categories.hoodies': 'Sweats / Hoodies',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Vestes',
  'categories.pants': 'Pantalons / Shorts',
  'categories.headwear': 'Couvre-chefs',
  'categories.sets': 'Ensembles',
  'categories.underwear': 'Sous-vêtements',
  'categories.jersey': 'Maillots',
  'categories.accessories': 'Accessoires',
  'categories.bags': 'Sacs',
  'categories.belts': 'Ceintures',
  'categories.perfumes': 'Parfums',
  'categories.other': 'Autres articles',
};